import { render, staticRenderFns } from "./PopOrderReminder.vue?vue&type=template&id=031d05fa&scoped=true&"
import script from "./PopOrderReminder.vue?vue&type=script&lang=js&"
export * from "./PopOrderReminder.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderReminder.vue?vue&type=style&index=0&id=031d05fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d05fa",
  null
  
)

export default component.exports